import React from 'react';
import { workInProgress } from '../../assets';
import Flex from './Flex';
import Typography from './Typographys';
import { TYPOGRAPHY } from '../../constants';

function WorkInProgress() {
  return (
    <>
      <Flex
        justify="center"
        vertical
        gap={20}
        align="center"
        className="w-full h-screen text-center p-4"
      >
        <div className="max-w-[500px] object-contain">
          <img src={workInProgress} alt="" className="w-full h-full" />
        </div>
        <Typography type={TYPOGRAPHY.TITLE} text="🚧 Work In Progress 🚧" />
        <Typography
          className="text-center"
          type={TYPOGRAPHY.PARA}
          text="We’re cooking up something amazing! 👨‍💻✨ Our site is still under development, so expect a little dust while we perfect the magic.
Stay tuned—good things are loading... ⏳🚀"
        />
      </Flex>
    </>
  );
}

export default WorkInProgress;
